import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import {
  UNASSIGNED_PRODUCTS_TAB_ID,
  UNASSIGNED_ROOMS_TAB_ID
} from "entities/project-children/lib/projectTabIDs"

export interface NoProductsHintProps {
  activeTabID?: string | null
}

export const NoProductsHint = React.memo(
  ({ activeTabID }: NoProductsHintProps) => {
    const { t } = useTranslation()

    const isViewingFloor =
      activeTabID &&
      activeTabID !== UNASSIGNED_PRODUCTS_TAB_ID &&
      activeTabID !== UNASSIGNED_ROOMS_TAB_ID

    return (
      <Hint.Root data-testid="no-products-hint">
        <Hint.Icon name={IconName.INFO} size={IconSize.XS} />
        <Hint.Content>
          <Hint.Title>
            {isViewingFloor
              ? t("Project.EmptyStateFloorTitle")
              : t("Project.EmptyStateProjectTitle")}
          </Hint.Title>
          <Hint.Text>
            {isViewingFloor
              ? t("Project.EmptyStateFloorDescription")
              : t("Project.EmptyStateProjectDescription")}
          </Hint.Text>
        </Hint.Content>
      </Hint.Root>
    )
  }
)
